import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { WithRedactedTooltip } from '../../../components/attack-event/with-redacted-tooltip'

function Bridge(props) {
  const { value } = props
  if (value === null || value === undefined) {
    throw new Error('Value is required for Redacted Tooltip')
  }
  return <WithRedactedTooltip text={value} />
}

export const reactSensitiveRedactedDataTooltip = createNgReactBridgeDirective(
  'reactSensitiveRedactedDataTooltip',
  [],
  Bridge,
  ['value']
)
